(function () {
  var D = window.NPDP;
  // Accent colour: Efectiv yellow, or VOLT lime on VOLT product pages (new-pdp swaps it in NPDP.accent).
  var ACC = (D && D.accent) || "#FFDD0E";
  if (document.querySelector(".lipscore-rating-small") && !document.querySelector('script[src*="lipscore"]')) {
    window.lipscoreInit = function () { window.lipscore.init({ apiKey: "54b15725d0301f12251693f6" }); };
    var lsc = document.createElement("script");
    lsc.async = 1;
    lsc.src = "https://static.lipscore.com/assets/en/lipscore-v1.js";
    document.head.appendChild(lsc);
  }
  var TABS = D.tabs;
  var GOALS = [
    { ratio: 1.4, label: "Maintaining muscle" },
    { ratio: 1.8, label: "Building muscle" },
    { ratio: 2.2, label: "Cutting on a deficit" }
  ];
  var s = { flavour: D.startIdx, opt2: D.startOpt2, opt3: D.startOpt3, img: 0, plan: D.hasSubs ? "sub" : "once", qty: 1, addons: {}, tab: D.startTab, goal: 1, kg: 80 };
  var heroInit = true;
  var $ = function (id) { return document.getElementById(id); };
  var all = function (sel) { return document.querySelectorAll(sel); };
  var money = function (p) { return "£" + (p / 100).toFixed(2); };
  /* Black web renders (test theme, 6 Oct 2026): a variant with a front render (variants[].bk, from
     snippets/np-bk.liquid) uses it as its main photo, and as the swatch/tile/band image where the
     product has no flavour art. The gallery's other photos are unchanged, apart from bk.more, and
     the old main photo is dropped from them (oldTub) so the render replaces it rather than joins it. */
  D.variants.forEach(function (v) {
    if (!v.bk) return;
    v.oldTub = v.tub; v.tub = v.bk.tub; v.tubSm = v.bk.tubSm;
    if (!v.hasArt) { v.sw = v.bk.sw; v.tile = v.bk.tile; v.lg = v.bk.lg; }
  });

  /* Resolve the actual purchasable variant. Almost every product has a
     single variant axis, so s.flavour already IS the variants[] index and
     this is a direct lookup. A genuine second axis (D.hasOpt2, e.g. Colour x
     Size) means variants[] outnumbers the flavour swatches, so the real
     variant is found by matching BOTH the selected flavour and the selected
     second-option value. A third axis (D.hasOpt3, VOLT Knee Sleeves: Thickness
     x Size x Colour, 3 Nov 2026) is matched the same way. */
  function opt3Ok(v, val) { return !D.hasOpt3 || v.opt3 === val; }
  function curVariant() {
    if (!D.hasOpt2) return D.variants[s.flavour];
    for (var i = 0; i < D.variants.length; i++) {
      var v = D.variants[i];
      if (v.flavIdx === s.flavour && v.opt2 === s.opt2 && opt3Ok(v, s.opt3)) return v;
    }
    return D.variants[0];
  }
  function comboAvailable(flavIdx, opt2Val, opt3Val) {
    for (var i = 0; i < D.variants.length; i++) {
      var v = D.variants[i];
      if (v.flavIdx === flavIdx && v.opt2 === opt2Val && opt3Ok(v, opt3Val)) return !!v.available;
    }
    return false;
  }
  /* id/price/available/tub come from the resolved variant; hex/tint/name/
     images are flavour-only (size-agnostic) so they come from D.flavours
     when it exists. When it doesn't (the common case), variants[] already
     carries both, so this is exactly today's plain lookup. */
  function fl() {
    var v = curVariant();
    if (!D.flavours) return v;
    var disp = D.flavours[s.flavour] || D.flavours[0];
    var out = {};
    for (var k in v) { if (v.hasOwnProperty(k)) out[k] = v[k]; }
    out.hex = disp.hex; out.tint = disp.tint; out.dark = disp.dark; out.note = disp.note;
    out.name = disp.name; out.hasArt = disp.hasArt; out.protein = disp.protein; out.kcal = disp.kcal;
    out.sw = disp.sw; out.tile = disp.tile; out.lg = disp.lg;
    return out;
  }
  /* Flavour-specific media by filename: "<slot>-<slug>" beats the shared image. */
  function findMedia(slug, keys) {
    if (!slug) return null;
    for (var i = 0; i < D.media.length; i++) {
      var m = D.media[i];
      if (m.n.indexOf(slug) > -1) {
        for (var k = 0; k < keys.length; k++) {
          if (m.n.indexOf(keys[k]) > -1) return m;
        }
      }
    }
    return null;
  }
  /* Gear with photos per colour (Adam, 3 Nov 2026: "Images need to be changing to all the pink editions"): the slots
     after the main photo show the chosen colour's own photos, found by the colour in the file name
     ("...-pink-top-down.jpg", "...-novabelt-pink-logo.jpg"), then photos whose names carry no colour at all. Variant
     main photos (media[].vi) are left out, since the first slot already shows the chosen one. A product with no
     colour-named photos returns null and keeps the four shared slots. */
  function slugOf(s) { return String(s || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, ""); }
  function colourExtras(f) {
    if (!D.isMerch || !D.media.length) return null;
    var list = D.flavours || D.variants, slugs = [], seen = {};
    for (var i = 0; i < list.length; i++) {
      var sl = slugOf(list[i].name);
      if (sl && !seen[sl]) { seen[sl] = 1; slugs.push(sl); }
    }
    if (slugs.length < 2) return null;
    var mine = slugOf(f.name), own = [], neutral = [], named = false;
    D.media.forEach(function (m) {
      if (m.vi) return;
      var hits = slugs.filter(function (sl) { return m.n.indexOf(sl) > -1; });
      if (hits.length) { named = true; if (hits.indexOf(mine) > -1) own.push(m); }
      else neutral.push(m);
    });
    if (!named) return null;
    return own.concat(neutral).slice(0, 4).map(function (m) { return { src: m.u, sm: m.s }; });
  }
  /* Gear: the photo with the product name on it leads the gallery (custom.lead_images: "photo key" or "value, value |
     photo key" per line, e.g. "5mm, BlackEdition | proflex-5mm-blackedition"; the first line whose values are all
     chosen wins). Adam 3 Nov 2026: "There is one for each colour", so it follows every choice. */
  function leadFor(f) {
    if (!D.isMerch || !D.leads) return null;
    var picked = [f.name, s.opt2, s.opt3], lines = String(D.leads).split(/\r?\n/);
    for (var i = 0; i < lines.length; i++) {
      var parts = lines[i].split("|"), key = parts[parts.length - 1].trim().toLowerCase();
      var when = parts.length > 1 ? parts[0].split(",").map(function (w) { return w.trim(); }) : [];
      if (!key || when.some(function (w) { return w && picked.indexOf(w) < 0; })) continue;
      for (var j = 0; j < D.media.length; j++) if (D.media[j].n.indexOf(key) > -1) return { src: D.media[j].u, sm: D.media[j].s };
    }
    return null;
  }
  /* VOLT colour dots (Adam 3 Nov 2026: "make the first one green / white circle and the second one black / dark grey.
     Same with belts"): two-tone, split on the diagonal, in the VOLT palette (Onyx #1A1A1A, Granite #4C4C4C, Volt Lime
     #C8F31B, Magenta #FF1D8E). Used only when every colour of the product has a dot, so the grip keeps its photos. */
  function voltDot(name) {
    var n = slugOf(name), LOGO = { original: "#C8F31B", grey: "#4C4C4C", pink: "#FF1D8E" }, pair = null;
    if (/^black-(original|grey|pink)$/.test(n)) pair = ["#1A1A1A", LOGO[n.slice(6)]];
    else pair = { "original": ["#C8F31B", "#FFFFFF"], "blackedition": ["#1A1A1A", "#4C4C4C"], "pink": ["#FF1D8E", "#1A1A1A"] }[n.replace(/^(ironbelt|novabelt)-/, "")] || null;
    return pair ? "linear-gradient(135deg, " + pair[0] + " 50%, " + pair[1] + " 50%)" : null;
  }
  var voltDots = (function () {
    if (!D.isMerch) return null;
    var list = D.flavours || D.variants, out = [];
    for (var i = 0; i < list.length; i++) { var d = voltDot(list[i].name); if (!d) return null; out.push(d); }
    return out.length > 1 ? out : null;
  })();
  /* "In detail" grid (snippets/np-merch-mid.liquid): each photo carries its colours as data-dt-srcs
     ({"pink": [url, alt], "_": [url, alt]}, "_" = a photo with no colour in its name); show the chosen one. */
  function paintDetail(f) {
    var sl = slugOf(f.name);
    all("[data-dt-srcs]").forEach(function (im) {
      var m;
      try { m = JSON.parse(im.getAttribute("data-dt-srcs")); } catch (e) { return; }
      var p = m[sl] || m._;
      if (p && im.getAttribute("src") !== p[0]) { im.src = p[0]; im.alt = p[1] || ""; }
    });
  }
  function gallery() {
    var f = fl();
    if (!D.isWhey) {
      /* extra renders after the front (Vegan: back + group shots), from variants[].bk.more */
      var more = f.bk && f.bk.more ? f.bk.more.u.map(function (u, i) { return { src: u, sm: f.bk.more.s[i] }; }) : [];
      /* old main photos the render replaces: the old tub image and the store's featured image */
      var oldMain = f.bk ? [f.oldTub, D.media.length ? D.media[0].u : null] : [];
      var lead = leadFor(f);
      var tail = colourExtras(f) || [
        { src: D.fixed.macros, sm: D.fixed.macrosSm },
        { src: D.fixed.inuse, sm: D.fixed.inuseSm },
        { src: D.fixed.life, sm: D.fixed.lifeSm },
        { src: D.fixed.timing, sm: D.fixed.timingSm }
      ];
      if (lead) tail = tail.filter(function (g) { return g.src !== lead.src; }).slice(0, 3);
      return (lead ? [lead] : []).concat([
        { src: f.tub, sm: f.tubSm },
        D.video ? { video: D.video, src: D.videoPoster, sm: D.videoThumb } : { src: null }
      ], more, [
        f.hasArt ? { src: f.lg, sm: f.sw } : { src: null }
      ], tail).filter(function (g) { return !!g.src && oldMain.indexOf(g.src) < 0; });
    }
    var mMac = findMedia(f.slug, ["macro", "info"]);
    var mUse = findMedia(f.slug, ["inuse", "in-use", "in_use"]);
    var mLife = findMedia(f.slug, ["life"]);
    return [
      { src: f.tub, sm: f.tubSm },
      { src: f.lg, sm: f.sw },
      { src: mMac ? mMac.u : D.fixed.macros, sm: mMac ? mMac.s : D.fixed.macrosSm },
      { src: mUse ? mUse.u : D.fixed.inuse, sm: mUse ? mUse.s : D.fixed.inuseSm },
      { src: mLife ? mLife.u : D.fixed.life, sm: mLife ? mLife.s : D.fixed.lifeSm }
    ];
  }
  function unit() { return s.plan === "sub" ? fl().subPrice : fl().price; }
  function addonTotal() {
    var t = 0;
    all("[data-aidx]").forEach(function (b) { if (s.addons[b.dataset.avid]) t += parseInt(b.dataset.aprice, 10); });
    return t;
  }
  function total() { return unit() * s.qty + addonTotal(); }
  function addonCount() { return Object.keys(s.addons).filter(function (k) { return s.addons[k]; }).length; }

  /* Band copy colour follows the ground it sits on (contrast pass, 12 Oct 2026). The band is the flavour's colour (f.dark) under a
     left-to-right ink scrim that is still about 25% ink at its lightest over the copy, so white copy holds on every flavour set up
     so far. If store data gives a flavour a colour so light that white copy would fall below 4.5:1 on that scrimmed ground, the band
     takes data-tone="light" and np-pdp.css sets ink copy on a light veil instead. Relative luminance is WCAG 2.x's. */
  var BAND_SCRIM = 0.25, BAND_INK = 11;
  function relLum(rgb) {
    var c = rgb.map(function (v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); });
    return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  }
  function bandTone(hex) {
    var m = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(String(hex || "").replace(/\s/g, ""));
    if (!m) return "dark";
    var h = m[1].length === 3 ? m[1].replace(/./g, "$&$&") : m[1];
    var ground = [0, 2, 4].map(function (i) { return parseInt(h.substr(i, 2), 16) * (1 - BAND_SCRIM) + BAND_INK * BAND_SCRIM; });
    return 1.05 / (relLum(ground) + 0.05) >= 4.5 ? "dark" : "light";
  }

  function render() {
    var f = fl();
    var gal = gallery();
    var shot = gal[Math.min(s.img, gal.length - 1)];

    $("np-tint").style.background = f.tint;
    var hi = $("np-hero-img");
    if (shot.src) {
      /* Leave the browser's own srcset/sizes pick alone for the very first
         paint (that is the real LCP win); once the shopper changes flavour
         or gallery slot, drop srcset so the JS-driven src actually wins
         instead of the browser re-resolving stale candidates against it. */
      if (!heroInit) { hi.removeAttribute("srcset"); hi.removeAttribute("sizes"); hi.src = shot.src; }
      hi.style.opacity = 1;
    } else {
      hi.style.opacity = 0;
    }
    var hv = $("np-hero-video");
    if (hv) {
      if (shot.video) {
        /* source attached on first use: the video sits behind a gallery tap,
           so most visitors never need it and should never download it */
        if (!hv.getAttribute("src") && hv.dataset.src) hv.src = hv.dataset.src;
        hv.style.display = "block"; hi.style.opacity = 0; var pp = hv.play(); if (pp && pp.catch) pp.catch(function () {});
      }
      else { hv.style.display = "none"; hv.pause(); }
    }
    if (D.isWhey) { $("np-chip").textContent = f.protein + "G PROTEIN"; calc(); }
    $("np-soldflag").style.display = f.available ? "none" : "block";
    /* a sold-out flavour or colour must not promise delivery (9 Oct pre-launch check) */
    if ($("np-arrivalrow")) $("np-arrivalrow").style.display = f.available ? "flex" : "none";
    if ($("np-flavname")) $("np-flavname").textContent = f.name;

    all("[data-gidx]").forEach(function (b, i) {
      var g = gal[i];
      var img = b.querySelector("[data-gimg]");
      if (!g) { b.style.display = "none"; return; }
      b.style.display = "block";
      var play = b.querySelector("[data-gplay]");
      if (play) play.style.display = g.video ? "flex" : "none";
      if (g.sm) { img.src = g.sm; img.style.opacity = i === s.img ? 1 : 0.6; } else { img.removeAttribute("src"); img.style.opacity = 0; }
      b.querySelector("[data-gring]").style.opacity = i === s.img ? 1 : 0;
    });

    var flavList = D.flavours || D.variants;
    all("[data-fidx]").forEach(function (b, i) {
      var v = flavList[i];
      var img = b.querySelector("[data-fsw]");
      if (voltDots) { img.style.opacity = 0; b.querySelector(".np-swbox > span").style.background = voltDots[i]; }
      else if (v.sw) { img.src = v.sw; img.style.opacity = 1; } else { img.style.opacity = 0; }
      var on = i === s.flavour;
      b.querySelector("[data-fring]").style.opacity = on ? 1 : 0;
      b.querySelector("[data-fname]").style.opacity = on ? 1 : 0.62;
      b.setAttribute("aria-pressed", on ? "true" : "false");
      var ok = D.hasOpt2 ? comboAvailable(i, s.opt2, s.opt3) : v.available !== false;
      b.style.opacity = ok ? 1 : 0.4;
      b.setAttribute("aria-disabled", ok ? "false" : "true");
    });

    all("[data-tidx]").forEach(function (b, i) {
      var v = flavList[i];
      var img = b.querySelector("[data-timg]");
      if (v.tile) { img.src = v.tile; img.style.opacity = 1; } else { img.style.opacity = 0; }
      var on = i === s.flavour;
      b.querySelector("[data-tdim]").style.opacity = on ? 0 : 0.42;
      b.querySelector("[data-tring]").style.opacity = on ? 1 : 0;
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });

    if (D.hasOpt2) {
      var paintOpt = function (b, on, ok) {
        b.setAttribute("aria-pressed", on ? "true" : "false");
        b.setAttribute("aria-disabled", ok ? "false" : "true");
        b.style.opacity = ok ? 1 : 0.4;
        b.style.borderColor = on ? "#0B0B0B" : "rgba(11,11,11,.18)";
        b.style.background = on ? "#0B0B0B" : "#fff";
        b.style.color = on ? "#fff" : "#0B0B0B";
      };
      if ($("np-opt2name")) $("np-opt2name").textContent = s.opt2 || "";
      all("[data-optval]").forEach(function (b) {
        paintOpt(b, b.dataset.optval === s.opt2, comboAvailable(s.flavour, b.dataset.optval, s.opt3));
      });
      if (D.hasOpt3) {
        if ($("np-opt3name")) $("np-opt3name").textContent = s.opt3 || "";
        all("[data-opt3val]").forEach(function (b) {
          paintOpt(b, b.dataset.opt3val === s.opt3, comboAvailable(s.flavour, s.opt2, b.dataset.opt3val));
        });
      }
    }

    var band = $("np-band");
    if (band) {
      band.style.background = f.dark;
      band.setAttribute("data-tone", bandTone(f.dark));
      var bimg = $("np-band-img");
      if (f.lg) { bimg.src = f.lg; bimg.style.opacity = 1; } else { bimg.style.opacity = 0; }
      $("np-bandname").textContent = f.name;
      if (D.isWhey) { $("np-band-protein").textContent = f.protein + "g"; $("np-band-kcal").textContent = f.kcal; }
      $("np-bandcta").textContent = f.available ? "Add " + f.name + " · " + money(total()) : f.name + " · sold out";
    }

    var tintcard = document.querySelector("[data-tintcard]");
    if (tintcard) tintcard.style.background = f.tint;
    if (D.isMerch) paintDetail(f);

    if (D.hasSubs) {
      $("np-subprice").textContent = money(fl().subPrice * s.qty);
      $("np-subwas").textContent = money(fl().price * s.qty);
      var subOn = s.plan === "sub";
      var sr = $("np-subrow"), or_ = $("np-oncerow");
      sr.setAttribute("aria-pressed", subOn ? "true" : "false");
      or_.setAttribute("aria-pressed", subOn ? "false" : "true");
      sr.style.background = subOn ? "#F5F4F0" : "#fff";
      or_.style.background = subOn ? "#fff" : "#F5F4F0";
      sr.querySelector("[data-radio]").style.borderColor = subOn ? "#0B0B0B" : "rgba(11,11,11,.28)";
      sr.querySelector("[data-radio]").style.background = subOn ? "#0B0B0B" : "transparent";
      sr.querySelector("[data-dot]").style.opacity = subOn ? 1 : 0;
      or_.querySelector("[data-radio]").style.borderColor = subOn ? "rgba(11,11,11,.28)" : "#0B0B0B";
      or_.querySelector("[data-radio]").style.background = subOn ? "transparent" : "#0B0B0B";
      or_.querySelector("[data-dot]").style.opacity = subOn ? 0 : 1;
      $("np-freqwrap").style.display = subOn ? "block" : "none";
    }
    $("np-onceprice").textContent = money(fl().price * s.qty);
    /* price line under the rating: unit prices of the selected variant */
    if ($("np-hp-price")) {
      $("np-hp-price").textContent = money(fl().price);
      var hpServ = parseInt($("np-pricerow").getAttribute("data-serv"), 10) || 0;
      if (hpServ && $("np-hp-per")) $("np-hp-per").textContent = money(Math.round(fl().price / hpServ)) + " / serving";
      if ($("np-hp-sub")) $("np-hp-sub").textContent = money(fl().subPrice);
    }

    $("np-qty").textContent = s.qty;
    var n = addonCount();
    var atc = $("np-atc");
    atc.disabled = !f.available;
    atc.style.opacity = f.available ? 1 : 0.45;
    atc.style.cursor = f.available ? "pointer" : "not-allowed";
    $("np-atc-label").textContent = !f.available ? "Sold out, back soon" : (n ? "Add " + (s.qty + n) + " items" : "Add to cart");
    $("np-atc-total").textContent = f.available ? money(total()) : "";
    if ($("np-atc-sep")) $("np-atc-sep").hidden = !f.available;

    all("[data-aidx]").forEach(function (b) {
      var on = !!s.addons[b.dataset.avid];
      b.setAttribute("aria-pressed", on ? "true" : "false");
      b.style.background = on ? "#F5F4F0" : "#fff";
      b.querySelector("[data-abox]").style.borderColor = on ? "#0B0B0B" : "rgba(11,11,11,.28)";
      b.querySelector("[data-abox]").style.background = on ? "#0B0B0B" : "transparent";
      b.querySelector("[data-atick]").style.opacity = on ? 1 : 0;
      var avrow = b.parentNode.querySelector("[data-avrow]");
      if (avrow) avrow.style.background = on ? "#F5F4F0" : "#fff";
    });
    $("np-addon-note").textContent = n
      ? "Goes in with your tub on one click. Remove anytime in the cart."
      : "Tick to add to this order. Same price, one delivery.";

    $("np-bar-chip").style.background = f.hex;
    /* sticky bar image follows the flavour (Adam, 6 Oct: image missing from the sticky add to cart) */
    if ($("np-bar-img") && f.tubSm) $("np-bar-img").src = f.tubSm;
    $("np-bar-sub").textContent = (f.name ? f.name + " · " : "") + (s.plan === "sub" ? "Subscribe and save 15%" : "One-time") + " · " + s.qty + (s.qty === 1 ? " tub" : " tubs");
    $("np-bar-total").textContent = money(total());
    var batc = $("np-bar-atc");
    batc.disabled = !f.available;
    batc.style.opacity = f.available ? 1 : 0.45;
    batc.textContent = f.available ? "Add to cart" : "Sold out";
  }

  /* The address bar follows the chosen flavour or size as ?variant=<id> (Louis via Adam, 29 Oct 2026: "turn the variants
     into variants to generate URLs"), so the URL can be shared or bookmarked and opens on that flavour. replaceState, so
     trying flavours does not fill the back button. Other query values (utm and the like) are kept. */
  function syncUrl() {
    var v = curVariant();
    if (!v || !v.id || !window.history.replaceState) return;
    var u = new URL(window.location.href);
    if (u.searchParams.get("variant") === String(v.id)) return;
    u.searchParams.set("variant", v.id);
    window.history.replaceState(window.history.state, "", u.toString());
  }
  all("[data-fidx]").forEach(function (b) {
    /* the swatches are links to their ?variant= URL: keep the click on the page instead of reloading it */
    b.addEventListener("click", function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      e.preventDefault();
      s.flavour = parseInt(b.dataset.fidx, 10); s.img = 0; render(); syncUrl();
    });
    /* role="button" on a link: Space selects too, as it does on a real button */
    b.addEventListener("keydown", function (e) { if (e.key === " ") { e.preventDefault(); b.click(); } });
  });
  all("[data-tidx]").forEach(function (b) {
    b.addEventListener("click", function () { s.flavour = parseInt(b.dataset.tidx, 10); s.img = 0; render(); syncUrl(); });
  });
  all("[data-optval]").forEach(function (b) {
    b.addEventListener("click", function () { s.opt2 = b.dataset.optval; s.img = 0; render(); syncUrl(); });
  });
  all("[data-opt3val]").forEach(function (b) {
    b.addEventListener("click", function () { s.opt3 = b.dataset.opt3val; s.img = 0; render(); syncUrl(); });
  });
  all("[data-gidx]").forEach(function (b) {
    b.addEventListener("click", function () { s.img = parseInt(b.dataset.gidx, 10); render(); });
  });
  /* Swipe the main image on a phone (SEO contractor's CRO sheet, 22 Oct 2026): a sideways swipe moves to the next or
     previous photo, the same as tapping its thumbnail, and wraps round. Upright drags still scroll the page; a tap still
     opens the zoom, but the click that ends a swipe does not. */
  (function () {
    var wrap = $("np-herowrap");
    if (!wrap) return;
    var x0 = null, y0 = 0, swiped = false;
    wrap.addEventListener("touchstart", function (e) {
      if (e.touches.length !== 1) { x0 = null; return; }
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; swiped = false;
    }, { passive: true });
    wrap.addEventListener("touchend", function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      var n = gallery().length;
      if (n < 2) return;
      swiped = true;
      s.img = (Math.min(s.img, n - 1) + (dx < 0 ? 1 : n - 1)) % n;
      render();
    }, { passive: true });
    wrap.addEventListener("click", function (e) {
      if (swiped) { swiped = false; e.stopImmediatePropagation(); }
    }, true);
  })();
  if ($("np-subrow")) $("np-subrow").addEventListener("click", function () { s.plan = "sub"; render(); });
  $("np-oncerow").addEventListener("click", function () { s.plan = "once"; render(); });
  $("np-inc").addEventListener("click", function () { s.qty = Math.min(9, s.qty + 1); render(); });
  $("np-dec").addEventListener("click", function () { s.qty = Math.max(1, s.qty - 1); render(); });
  /* Add-on tracking (Adam 19 Oct 2026). Lines added from "Trains well with this" carry a hidden _addon_for = this
     product's id (Shopify hides "_" properties in the cart and checkout), so orders show which items came from the
     tick boxes (Peak Bundles > Analytics > Add-ons). Google Analytics gets addon_ticked and addon_added_to_cart
     through window.npTrack (np-chrome.js). */
  var pageProduct = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) || {};
  var pageId = pageProduct.id ? String(pageProduct.id) : "";
  var pageHandle = (location.pathname.split("/products/")[1] || "").split(/[/?#]/)[0];
  function addonName(b) { var t = b.children[2] && b.children[2].children[0]; return t ? t.textContent.trim() : ""; }
  function track(name, data) { if (window.npTrack) window.npTrack(name, data); }
  all("[data-aidx]").forEach(function (b) {
    b.addEventListener("click", function () {
      /* a gear add-on with sizes or colours has no variant until one is picked: send the shopper to the picker */
      if (!b.dataset.avid) {
        var need = b.parentNode.querySelector("[data-avsel]");
        if (need) { need.setAttribute("aria-invalid", "true"); need.style.borderColor = "#B42318"; need.focus(); }
        return;
      }
      s.addons[b.dataset.avid] = !s.addons[b.dataset.avid];
      if (s.addons[b.dataset.avid]) track("addon_ticked", { product: pageHandle, addon: addonName(b), value: parseInt(b.dataset.aprice, 10) / 100, currency: "GBP" });
      render();
    });
  });

  /* Gear add-on pickers (new-pdp: data-avsel): the chosen size or colour becomes the add-on's variant and ticks it. */
  all("[data-avsel]").forEach(function (sel) {
    var b = sel.parentNode.parentNode.querySelector("[data-aidx]");
    sel.addEventListener("change", function () {
      var o = sel.options[sel.selectedIndex], old = b.dataset.avid, was = !!(old && s.addons[old]);
      if (old) delete s.addons[old];
      b.dataset.avid = o.value || "";
      if (o.value) {
        b.dataset.aprice = o.dataset.price || b.dataset.aprice;
        var pl = b.querySelector("[data-aplabel]");
        if (pl && o.dataset.label) pl.textContent = o.dataset.label;
        s.addons[o.value] = true;
        if (!was) track("addon_ticked", { product: pageHandle, addon: addonName(b), value: parseInt(b.dataset.aprice, 10) / 100, currency: "GBP" });
      }
      sel.removeAttribute("aria-invalid"); sel.style.borderColor = "rgba(11,11,11,.2)";
      render();
    });
  });

  /* ---- add to cart via the shared cart API (assets/np-chrome.js) ---- */
  var atcInFlight = false;
  function addToCart() {
    if (atcInFlight) return;
    var f = fl();
    if (!f.available) return;
    var items = [{ id: f.id, quantity: s.qty }];
    if (s.plan === "sub" && D.hasSubs) {
      var freq = $("np-freq");
      items[0].selling_plan = freq ? parseInt(freq.value, 10) : D.defaultPlanId;
    }
    var addonValue = 0, addonNames = [];
    Object.keys(s.addons).forEach(function (vid) {
      if (!s.addons[vid]) return;
      var line = { id: parseInt(vid, 10), quantity: 1 };
      if (pageId) line.properties = { _addon_for: pageId };
      items.push(line);
      var btn = document.querySelector('[data-avid="' + vid + '"]');
      if (btn) { addonValue += parseInt(btn.dataset.aprice, 10) / 100; addonNames.push(addonName(btn)); }
    });

    var mainBtn = $("np-atc"), barBtn = $("np-bar-atc");
    var label = $("np-atc-label");
    var prevLabel = label ? label.textContent : "";
    atcInFlight = true;
    if (barBtn) barBtn.disabled = true;
    if (label) label.textContent = "Adding…";

    (window.npCart ? window.npCart.add(items, { button: mainBtn }) : Promise.reject(new Error("Please try again")))
      .then(function () {
        if (addonNames.length) track("addon_added_to_cart", { product: pageHandle, addons: addonNames.length, addon_names: addonNames.join(", "), value: Math.round(addonValue * 100) / 100, currency: "GBP" });
        s.addons = {};
      })
      .catch(function (err) {
        alert(err.message);
      })
      .then(function () {
        atcInFlight = false;
        if (barBtn) barBtn.disabled = false;
        if (label) label.textContent = prevLabel;
        render();
      });
  }
  $("np-atc").addEventListener("click", addToCart);
  $("np-bar-atc").addEventListener("click", addToCart);

  /* ---- sticky bar (its button must not be tabbable while off-screen) ---- */
  if ("IntersectionObserver" in window) {
    var barBtnEl = $("np-bar-atc");
    new IntersectionObserver(function (entries) {
      var hidden = entries[0].isIntersecting;
      $("np-bar").style.transform = hidden ? "translateY(110%)" : "translateY(0)";
      if (barBtnEl) {
        if (hidden) barBtnEl.setAttribute("tabindex", "-1"); else barBtnEl.removeAttribute("tabindex");
        barBtnEl.setAttribute("aria-hidden", hidden ? "true" : "false");
      }
    }, { rootMargin: "-8px 0px 0px 0px" }).observe($("np-atc"));
  }

  /* ---- arrival / cut-off: 4pm UK time on working days (window.npDispatch, np-chrome.js);
     express arrives the working day after dispatch ---- */
  (function () {
    if (!$("np-arrival") || !window.npDispatch) return;
    var d = window.npDispatch();
    $("np-arrival").textContent = d.addWorkingDays(d.date, 1).toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long" });
    $("np-cutoff").textContent = d.sameDay
      ? "order within " + Math.floor(d.minsLeft / 60) + "h " + (d.minsLeft % 60) + "m"
      : "next dispatch " + d.label;
  })();

  /* ---- calculator ---- */
  function calc() {
    if (!$("np-slider")) return;
    /* Whey varies by flavour (22g or 23g a scoop): use the chosen flavour's figure (9 Oct pre-launch check) */
    var fp = D.isWhey ? parseFloat(fl().protein) : NaN;
    var P = !isNaN(fp) && fp > 0 ? fp : (D.protein || 23);
    if ($("np-one")) $("np-one").textContent = P + "g";
    var g = GOALS[s.goal];
    var target = Math.round(s.kg * g.ratio);
    var cover = Math.min(100, Math.round((P / target) * 100));
    $("np-kg").textContent = s.kg;
    $("np-target").textContent = target;
    $("np-ratio").textContent = g.ratio.toFixed(1);
    $("np-goallabel").textContent = g.label;
    $("np-cover").textContent = cover;
    $("np-coverw").style.width = cover + "%";
    $("np-two").textContent = (P * 2) + "g · " + Math.min(100, Math.round(((P * 2) / target) * 100)) + "%";
    $("np-food").textContent = Math.max(0, target - P * 2) + "g";
    all("[data-goal]").forEach(function (b, i) {
      b.setAttribute("aria-pressed", i === s.goal ? "true" : "false");
      b.querySelector("[data-gbg]").style.opacity = i === s.goal ? 1 : 0;
      b.querySelector("[data-gink]").style.color = i === s.goal ? "#0B0B0B" : "#fff";
    });
  }
  if ($("np-slider")) $("np-slider").addEventListener("input", function () { s.kg = parseInt(this.value, 10); calc(); });
  all("[data-goal]").forEach(function (b) {
    b.addEventListener("click", function () { s.goal = parseInt(b.dataset.goal, 10); calc(); });
  });

  /* ---- timing tabs ---- */
  function tabs() {
    if (!$("np-tabstep")) return;
    if (s.tab >= TABS.length) s.tab = 0;
    var t = TABS[s.tab];
    $("np-tabstep").textContent = t.step;
    $("np-tabtitle").textContent = t.title;
    $("np-tabbody").textContent = t.body;
    all("[data-tab]").forEach(function (b, i) {
      b.setAttribute("aria-pressed", i === s.tab ? "true" : "false");
      b.querySelector("[data-tabbg]").style.opacity = i === s.tab ? 1 : 0;
    });
  }
  all("[data-tab]").forEach(function (b) {
    b.addEventListener("click", function () { s.tab = parseInt(b.dataset.tab, 10); tabs(); });
  });

  /* ---- accordions (details injected + faqs) ---- */
  function wireAccordions(scope) {
    (scope || document).querySelectorAll("[data-acc]").forEach(function (btn) {
      if (btn.__wired) return;
      btn.__wired = true;
      btn.addEventListener("click", function () {
        var body = btn.parentElement.querySelector("[data-accbody]");
        var plus = btn.querySelector("[data-accplus]");
        var open = body.style.maxHeight && body.style.maxHeight !== "0px";
        document.querySelectorAll("[data-accbody]").forEach(function (b) {
          if (b !== body) {
            b.style.maxHeight = "0px";
            var p = b.parentElement.querySelector("[data-accplus]"); if (p) p.style.transform = "rotate(0deg)";
            var ob = b.parentElement.querySelector("[data-acc]"); if (ob) ob.setAttribute("aria-expanded", "false");
          }
        });
        body.style.maxHeight = open ? "0px" : body.scrollHeight + "px";
        plus.style.transform = open ? "rotate(0deg)" : "rotate(45deg)";
        btn.setAttribute("aria-expanded", open ? "false" : "true");
      });
    });
  }
  wireAccordions();

  /* ---- details accordions (design DETAILS payload) ---- */
  var detailData = [
    { k: "Description", html: document.getElementById("np-detail-tpl-0").innerHTML },
    { k: "How to use", html: document.getElementById("np-detail-tpl-1").innerHTML },
    { k: "Delivery & payments", html: document.getElementById("np-detail-tpl-2").innerHTML }
  ];
  var dwrap = $("np-details");
  detailData.forEach(function (d, i) {
    var card = document.createElement("div");
    card.style.cssText = "background:#fff;border:1px solid rgba(11,11,11,.1);border-radius:18px;overflow:hidden";
    var bodyId = "np-detail-body-" + i;
    card.innerHTML =
      '<button type="button" data-acc aria-expanded="false" aria-controls="' + bodyId + '" style="width:100%;display:flex;align-items:center;gap:20px;padding:26px 28px;background:none;border:0;cursor:pointer;text-align:left">' +
      '<span style="font:500 10px/1 \'Kode Mono\',ui-monospace,monospace;letter-spacing:.14em;color:rgba(11,11,11,.62);flex:none">0' + (i + 1) + '</span>' +
      '<span style="font:700 19px/1.3 \'Xenon Nue\',\'Helvetica Neue\',Helvetica,Arial,sans-serif;letter-spacing:.005em;color:#0B0B0B">' + d.k + '</span>' +
      '<span data-accplus style="margin-left:auto;width:34px;height:34px;border-radius:50%;background:' + ACC + ';display:flex;align-items:center;justify-content:center;flex:none;font-size:17px;font-weight:600;color:#0B0B0B;transition:transform .35s cubic-bezier(.4,0,.2,1)">+</span>' +
      '</button>' +
      '<div data-accbody id="' + bodyId + '" style="overflow:hidden;transition:max-height .4s cubic-bezier(.4,0,.2,1);max-height:0px">' +
      '<div style="border-top:1px solid rgba(11,11,11,.1);margin:0 28px;padding:24px 0 30px">' +
      '<div style="font:400 15.5px/1.7 Inter,system-ui,sans-serif;color:rgba(11,11,11,.68);text-wrap:pretty">' + d.html + '</div>' +
      '</div></div>';
    dwrap.appendChild(card);
  });
  wireAccordions(dwrap);

  /* fourth row: opens the nutrition modal rather than expanding in place */
  var nutCard = document.createElement("div");
  nutCard.style.cssText = "background:#fff;border:1px solid rgba(11,11,11,.1);border-radius:18px;overflow:hidden";
  nutCard.innerHTML =
    '<button type="button" id="np-detail-nut" style="width:100%;display:flex;align-items:center;gap:20px;padding:26px 28px;background:none;border:0;cursor:pointer;text-align:left">' +
    '<span style="font:500 10px/1 \'Kode Mono\',ui-monospace,monospace;letter-spacing:.14em;color:rgba(11,11,11,.62);flex:none">04</span>' +
    '<span style="font:700 19px/1.3 \'Xenon Nue\',\'Helvetica Neue\',Helvetica,Arial,sans-serif;letter-spacing:.005em;color:#0B0B0B">Nutritional information</span>' +
    '<span style="font:400 12px/1.3 Inter,system-ui,sans-serif;color:rgba(11,11,11,.62);margin-left:6px" class="np-hidebar">Full supplement facts ' + D.servingFactsLabel + '</span>' +
    '<span style="margin-left:auto;width:34px;height:34px;border-radius:50%;background:' + ACC + ';display:flex;align-items:center;justify-content:center;flex:none;font-size:17px;font-weight:600;color:#0B0B0B">+</span>' +
    '</button>';
  dwrap.appendChild(nutCard);

  /* ---- reviews: our own pages over Lipscore's list (data-ls-page-size="10" in new-pdp.liquid). 10 a page on desktop,
     5 on phones; was 3 until 22 Oct 2026 (SEO contractor's CRO sheet: "5 to 10 reviews per page"). ---- */
  (function () {
    var rl = $("lipscore-review-list");
    if (!rl) return;
    var PER = window.matchMedia("(max-width:719px)").matches ? 5 : 10, cache = {}, vpage = 1, total = 0, pending = null, mine, pager;
    function paging() { try { return JSON.parse(rl.getAttribute("data-ls-review-paging")); } catch (e) { return null; } }
    var summary;
    function renderSummary() {
      if (summary) return;
      var r10 = parseFloat(rl.getAttribute("data-ls-product-rating"));
      var votes = parseInt(rl.getAttribute("data-ls-product-votes"), 10) || 0;
      var count = parseInt(rl.getAttribute("data-ls-product-review-count"), 10) || 0;
      var dist = {};
      try { dist = JSON.parse(rl.getAttribute("data-ls-rating-distribution")) || {}; } catch (e) {}
      if (!r10 || !votes) return;
      var r5 = Math.round(r10 / 2 * 10) / 10;
      var rows = "";
      for (var star = 5; star >= 1; star--) {
        var n = dist["0" + star] || dist[String(star)] || 0;
        var pct = votes ? Math.round(n / votes * 100) : 0;
        rows += '<div class="np-rs-row">' +
          '<span style="font:500 11px/1 \'Kode Mono\',ui-monospace,monospace;color:rgba(11,11,11,.62);width:22px;flex:none">' + star + '★</span>' +
          '<span style="flex:1;height:7px;border-radius:100px;background:rgba(11,11,11,.1);overflow:hidden;display:block"><span style="display:block;height:100%;border-radius:100px;background:#0B0B0B;width:' + pct + '%"></span></span>' +
          '<span style="font:500 11px/1 \'Kode Mono\',ui-monospace,monospace;color:rgba(11,11,11,.62);width:34px;text-align:right;flex:none">' + n + '</span></div>';
      }
      summary = document.createElement("div");
      summary.id = "np-revsummary";
      summary.innerHTML =
        '<div>' +
          '<div style="font:500 10px/1 \'Kode Mono\',ui-monospace,monospace;letter-spacing:.14em;text-transform:uppercase;color:rgba(11,11,11,.62);margin-bottom:14px">Average rating</div>' +
          '<div style="display:flex;align-items:baseline;gap:14px;margin-bottom:10px"><span style="font:800 52px/1 \'Xenon Nue\',\'Helvetica Neue\',Helvetica,Arial,sans-serif;letter-spacing:-.012em">' + r5.toFixed(1) + '</span>' +
          '<span class="np-rs-stars">★★★★★<span style="width:' + (r5 / 5 * 100) + '%">★★★★★</span></span></div>' +
          '<div style="font:400 13.5px/1.5 Inter,system-ui,sans-serif;color:rgba(11,11,11,.62)">Based on ' + votes + (votes == 1 ? ' rating' : ' ratings') + ' and ' + count + (count == 1 ? ' review' : ' reviews') + '</div>' +
        '</div>' +
        '<div>' + rows + '</div>';
      rl.insertBefore(summary, rl.firstChild);
    }
    function ensureUI() {
      if (mine) return;
      mine = document.createElement("div"); mine.id = "np-revlist";
      pager = document.createElement("div"); pager.id = "np-revpager";
      rl.appendChild(mine); rl.appendChild(pager);
    }
    var sigs = {};
    function currentPage() {
      var act = rl.querySelector(":scope > .lipscore-paginator li.active");
      if (act && act.getAttribute("data-pagenum")) return parseInt(act.getAttribute("data-pagenum"), 10);
      var pg = paging(); return pg && pg.page ? pg.page : 1;
    }
    function harvest() {
      var pg = paging();
      if (pg && pg.total_count) total = pg.total_count;
      var boxes = rl.querySelectorAll(":scope > .lipscore-review-list-box-container .lipscore-review-box");
      if (!boxes.length || !total) return false;
      var page = currentPage();
      var sig = (boxes[0].innerText || "").replace(/\s+/g, " ").slice(0, 120);
      if (!cache[page]) {
        /* Lipscore flips the active page before it swaps the cards — skip until the cards actually change */
        for (var k in sigs) { if (sigs[k] === sig) return false; }
        cache[page] = Array.prototype.map.call(boxes, function (b) { return b.cloneNode(true); });
        sigs[page] = sig;
      }
      if (pending === page && cache[page]) pending = null;
      return true;
    }
    function lsSize() { return (cache[1] || []).length || 5; }
    function render() {
      ensureUI();
      renderSummary();
      var size = lsSize(), start = (vpage - 1) * PER, items = [], need = null;
      for (var i = start; i < Math.min(start + PER, total); i++) {
        var lp = Math.floor(i / size) + 1, off = i % size;
        if (cache[lp] && cache[lp][off]) items.push(cache[lp][off]); else if (!need) need = lp;
      }
      if (need) {
        if (pending !== need) {
          pending = need;
          var a = rl.querySelector('.lipscore-paginator li[data-pagenum="' + need + '"] a');
          if (a) a.click();
        }
        return;
      }
      mine.innerHTML = "";
      items.forEach(function (n) { mine.appendChild(n.cloneNode(true)); });
      var pages = Math.max(1, Math.ceil(total / PER));
      pager.innerHTML =
        '<button type="button" data-prev' + (vpage <= 1 ? ' disabled' : '') + '>Previous</button>' +
        '<span style="font:500 10px/1 \'Kode Mono\',ui-monospace,monospace;letter-spacing:.14em;text-transform:uppercase;color:rgba(11,11,11,.62)">Page ' + vpage + ' of ' + pages + ' · ' + total + (total == 1 ? ' review' : ' reviews') + '</span>' +
        '<button type="button" data-next' + (vpage >= pages ? ' disabled' : '') + '>Next</button>';
      pager.querySelector("[data-prev]").addEventListener("click", function () { vpage = Math.max(1, vpage - 1); render(); });
      pager.querySelector("[data-next]").addEventListener("click", function () { vpage = Math.min(pages, vpage + 1); render(); scrollIntoViewIfNeeded(); });
    }
    function scrollIntoViewIfNeeded() {
      var top = mine.getBoundingClientRect().top;
      if (top < 0) window.scrollTo({ top: window.scrollY + top - 120, behavior: "smooth" });
    }
    /* The reviews.* metafields that render server-side stopped updating in
       2024; once Lipscore loads, its live rating/count replace them. */
    var liveDone = false;
    function applyLive() {
      if (liveDone) return;
      var r10 = parseFloat(rl.getAttribute("data-ls-product-rating"));
      var votes = parseInt(rl.getAttribute("data-ls-product-votes"), 10) || 0;
      if (!r10 || !votes) return;
      liveDone = true;
      /* same double rounding as the server (metafield stores 2dp, Liquid
         rounds that to 1dp), so a synced metafield never visibly swaps */
      var r5 = (Math.round(Math.round(r10 * 50) / 100 * 10) / 10).toFixed(1);
      all("[data-np-rv]").forEach(function (el) { el.textContent = r5; });
      all("[data-np-rc]").forEach(function (el) { el.textContent = votes; });
      all("[data-np-rw]").forEach(function (el) { el.textContent = el.getAttribute(+votes === 1 ? "data-one" : "data-many"); });
      all("[data-np-rp]").forEach(function (el) { el.style.setProperty("--pct", Math.min(100, r10 * 10) + "%"); });
    }
    new MutationObserver(function (muts) {
      applyLive();
      for (var i = 0; i < muts.length; i++) { var t = muts[i].target; if ((mine && mine.contains(t)) || (pager && pager.contains(t)) || (summary && summary.contains(t))) return; }
      if (harvest()) render();
    }).observe(rl, { childList: true, subtree: true, attributes: true, attributeFilter: ["data-ls-review-paging", "data-ls-product-rating"] });
    applyLive();
    if (harvest()) render();
  })();

  /* ---- full-label groups (ACTIVE INGREDIENTS etc.) ---- */
  all("[data-nutgroup]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var body = btn.nextElementSibling, plus = btn.querySelector("[data-nutplus]");
      var open = body.style.maxHeight && body.style.maxHeight !== "0px";
      body.style.maxHeight = open ? "0px" : body.scrollHeight + "px";
      plus.style.transform = open ? "rotate(0deg)" : "rotate(45deg)";
      btn.setAttribute("aria-expanded", open ? "false" : "true");
    });
  });

  /* ---- hero video: retry playback once media is ready / tab is visible ---- */
  (function () {
    var hv = $("np-hero-video");
    if (!hv) return;
    function tryPlay() { if (hv.style.display === "block" && hv.paused) { var p = hv.play(); if (p && p.catch) p.catch(function () {}); } }
    hv.addEventListener("canplay", tryPlay);
    document.addEventListener("visibilitychange", function () { if (!document.hidden) tryPlay(); });
  })();

  /* ---- Hydration + Energy: energy curve, serving calculator, video toggle ---- */
  (function () {
    var hour = $("he-hour");
    if (hour) {
      var HOURS = [
        { label: "0 hours", title: "One scoop, 500ml", body: "Ten seconds in the shaker. 400mg of sodium and the full five-salt profile go down before you start sweating." },
        { label: "1 hour", title: "Switching on", body: "The caffeine is working and L-theanine, at twice the dose, keeps the edge off it. A sugary can is at its peak right here." },
        { label: "2 hours", title: "Level", body: "Still steady. This is the stretch a sugar spike cannot hold on to, and where most people reach for a second can." },
        { label: "3 hours", title: "Holding", body: "Energy tapers gently rather than dropping. Electrolytes are still doing the hydration half of the job." },
        { label: "4 hours", title: "No crash", body: "You come down instead of falling off. No 2pm slump to work around, and no second caffeine hit needed to fix one." }
      ];
      var ENERGY = [10, 78, 88, 76, 58], SPIKE = [10, 100, 64, 26, 12];
      function curve() {
        var h = parseInt(hour.value, 10) || 0;
        $("he-energy-pct").textContent = ENERGY[h]; $("he-energy-w").style.width = ENERGY[h] + "%";
        $("he-spike-pct").textContent = SPIKE[h]; $("he-spike-w").style.width = SPIKE[h] + "%";
        $("he-hour-label").textContent = HOURS[h].label; $("he-hour-title").textContent = HOURS[h].title; $("he-hour-body").textContent = HOURS[h].body;
      }
      hour.addEventListener("input", curve); curve();
    }
    var bw = $("he-bw");
    if (bw) {
      var st = { bw: 75, hrsStep: 3, level: 1, chip: 0 };
      var NOTES = [
        "100mg · a light, clean lift, about one espresso.",
        "200mg · a double-espresso day. Keep the second one before 2pm.",
        "300mg · a long day. Take the last serving early afternoon.",
        "400mg · the daily maximum. Nothing else caffeinated on top."
      ];
      function calcHE() {
        var hrs = st.hrsStep * 0.5;
        var rate = (0.55 + 0.2 * st.level) * (st.bw / 75);
        var sweatMl = Math.round(rate * hrs * 1000);
        var servings = Math.max(1, Math.min(4, Math.round(sweatMl / 550)));
        var chip = st.chip || servings;
        $("he-bw-label").textContent = st.bw + "kg";
        $("he-hrs-label").textContent = hrs + (hrs === 1 ? " hour" : " hours");
        $("he-servings").textContent = servings;
        $("he-servword").textContent = servings === 1 ? "serving" : "servings";
        $("he-fluid").textContent = (servings * 500) + "ml";
        $("he-caf").textContent = (servings * 100) + "mg";
        $("he-sweat").textContent = "~" + Math.round(sweatMl * 0.9) + "ml";
        $("he-chipnote").textContent = NOTES[chip - 1];
        all("[data-helevel]").forEach(function (b) {
          var on = parseInt(b.getAttribute("data-helevel"), 10) === st.level;
          b.style.background = on ? ACC : "transparent"; b.style.color = on ? "#0B0B0B" : "#fff"; b.style.borderColor = on ? ACC : "rgba(255,255,255,.28)";
        });
        all("[data-hechip]").forEach(function (b) {
          var on = parseInt(b.getAttribute("data-hechip"), 10) === chip;
          b.style.background = on ? ACC : "transparent"; b.style.color = on ? "#0B0B0B" : "#fff"; b.style.borderColor = on ? ACC : "rgba(255,255,255,.28)";
        });
      }
      bw.addEventListener("input", function () { st.bw = parseInt(bw.value, 10); calcHE(); });
      $("he-hrs").addEventListener("input", function () { st.hrsStep = parseInt($("he-hrs").value, 10); calcHE(); });
      all("[data-helevel]").forEach(function (b) { b.addEventListener("click", function () { st.level = parseInt(b.getAttribute("data-helevel"), 10); st.chip = 0; calcHE(); }); });
      all("[data-hechip]").forEach(function (b) { b.addEventListener("click", function () { st.chip = parseInt(b.getAttribute("data-hechip"), 10); calcHE(); }); });
      calcHE();
    }
    var hev = $("he-video"), hevBtn = $("he-video-toggle");
    if (hev && hevBtn) {
      hevBtn.addEventListener("click", function () {
        if (hev.paused) { hev.play(); hevBtn.textContent = "❚❚"; } else { hev.pause(); hevBtn.textContent = "▶"; }
      });
      var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (!reduceMotion && "IntersectionObserver" in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { var p = hev.play(); if (p && p.catch) p.catch(function () {}); hevBtn.textContent = "❚❚"; }
            else { hev.pause(); hevBtn.textContent = "▶"; }
          });
        }, { threshold: 0.35 }).observe(hev);
      }
    }
  })();

  /* ---- Sleep Powder: bedtime calculator (design logic: whole 90-minute cycles) ---- */
  (function () {
    var wake = $("sl-wake"), need = $("sl-need");
    if (!wake || !need) return;
    var LOADS = [0, 30, 60], st = { wake: 390, need: 480, load: 1 };
    function pad2(n) { n = String(n); return n.length < 2 ? "0" + n : n; }
    function clockAt(m) { m = ((m % 1440) + 1440) % 1440; return pad2(Math.floor(m / 60)) + ":" + pad2(m % 60); }
    function hoursLabel(m) { return Math.floor(m / 60) + "h" + (m % 60 ? " " + (m % 60) + "m" : ""); }
    function run() {
      var snapped = Math.max(270, Math.round((st.need + LOADS[st.load]) / 90) * 90);
      $("sl-wake-label").textContent = clockAt(st.wake); $("sl-wake-label2").textContent = clockAt(st.wake);
      $("sl-need-label").textContent = hoursLabel(snapped); $("sl-need-label2").textContent = hoursLabel(snapped);
      $("sl-lightsout").textContent = clockAt(st.wake - snapped - 15);
      $("sl-dose").textContent = clockAt(st.wake - snapped - 60);
      $("sl-screens").textContent = clockAt(st.wake - snapped - 75);
      $("sl-cycles").textContent = (snapped / 90) + " × 90 min";
      all("[data-slload]").forEach(function (b, i) {
        b.setAttribute("aria-pressed", i === st.load ? "true" : "false");
        b.querySelector("[data-slbg]").style.opacity = i === st.load ? 1 : 0;
        b.querySelector("[data-slink]").style.color = i === st.load ? "#0B0B0B" : "#fff";
      });
    }
    wake.addEventListener("input", function () { st.wake = parseInt(wake.value, 10); run(); });
    need.addEventListener("input", function () { st.need = parseInt(need.value, 10); run(); });
    all("[data-slload]").forEach(function (b) { b.addEventListener("click", function () { st.load = parseInt(b.getAttribute("data-slload"), 10); run(); }); });
    run();
  })();

  /* ---- focus trap: keeps Tab cycling inside an open dialog ---- */
  function npTrapTab(e, container) {
    if (e.key !== "Tab") return;
    var f = container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---- hero lightbox ---- */
  (function () {
    var wrap = $("np-herowrap"), zoomBtn = $("np-zoom-btn"), lb = $("np-lightbox");
    if (!wrap || !lb) return;
    var lbv = null, lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      var hv = $("np-hero-video"), img = $("np-lightbox-img");
      if (hv && hv.style.display === "block") {
        if (!lbv) { lbv = document.createElement("video"); lbv.muted = true; lbv.loop = true; lbv.playsInline = true; lbv.controls = true; lbv.style.cssText = "position:relative;max-width:min(1100px,100%);max-height:100%;border-radius:16px;background:#0B0B0B"; lb.insertBefore(lbv, img); }
        lbv.src = hv.src; lbv.style.display = "block"; img.style.display = "none"; lbv.play();
      } else {
        if (lbv) { lbv.pause(); lbv.style.display = "none"; }
        img.style.display = "block"; img.src = $("np-hero-img").src;
      }
      lb.inert = false;
      lb.style.opacity = 1; lb.style.pointerEvents = "auto";
      var closeBtn = $("np-lightbox-close");
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      lb.style.opacity = 0; lb.style.pointerEvents = "none";
      lb.inert = true;
      if (lbv) lbv.pause();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function isOpen() { return lb.style.opacity === "1"; }
    wrap.addEventListener("click", open);
    if (zoomBtn) zoomBtn.addEventListener("click", function (e) { e.stopPropagation(); open(); });
    $("np-lightbox-close").addEventListener("click", close);
    $("np-lightbox-scrim").addEventListener("click", close);
    lb.addEventListener("keydown", function (e) { npTrapTab(e, lb); });
    window.npLightboxIsOpen = isOpen;
    window.npLightboxClose = close;
  })();

  /* ---- nutrition modal ---- */
  var nutLastFocus = null;
  function nut(open) {
    var m = $("np-nut");
    if (open) {
      nutLastFocus = document.activeElement;
      requestAnimationFrame(function () { window.npFitNutTitle && window.npFitNutTitle(); });
    }
    m.inert = !open;
    m.style.opacity = open ? 1 : 0;
    m.style.pointerEvents = open ? "auto" : "none";
    $("np-nut-card").style.transform = open ? "scale(1)" : "scale(.96)";
    if (open) { var c = $("np-nut-close"); if (c) c.focus(); }
    else if (nutLastFocus && nutLastFocus.focus) { nutLastFocus.focus(); }
  }
  function nutIsOpen() { return $("np-nut").style.opacity === "1"; }
  if ($("np-detail-nut")) $("np-detail-nut").addEventListener("click", function () { nut(true); });
  $("np-nut-close").addEventListener("click", function () { nut(false); });
  $("np-nut-scrim").addEventListener("click", function () { nut(false); });
  $("np-nut").addEventListener("keydown", function (e) { npTrapTab(e, $("np-nut")); });

  /* Escape closes whichever of the two dialogs is open. */
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    if (window.npLightboxIsOpen && window.npLightboxIsOpen()) { window.npLightboxClose(); return; }
    if (nutIsOpen()) nut(false);
  });

  /* ---- desktop: park the in-stock / rating cluster under the gallery.
         mobile: cluster stays in the buy column, but the in-stock row moves
         directly below the Add to cart button. ---- */
  var meta = $("np-buymeta"), metaSlot = $("np-buymeta-slot"), gallerySticky = $("np-gallery-sticky");
  var arrivalRow = $("np-arrivalrow"), arrivalSlot = $("np-arrival-slot");
  function placeMeta() {
    if (!meta || !metaSlot || !gallerySticky) return;
    if (window.innerWidth >= 1020) {
      if (arrivalRow.parentElement !== meta) meta.insertBefore(arrivalRow, meta.firstChild);
      if (meta.parentElement !== gallerySticky) { gallerySticky.appendChild(meta); meta.style.marginTop = "22px"; }
    } else {
      if (meta.parentElement !== metaSlot) { metaSlot.appendChild(meta); meta.style.marginTop = "0px"; }
      if (arrivalRow.parentElement !== arrivalSlot) arrivalSlot.appendChild(arrivalRow);
    }
  }

  /* Largest font size (min..max) that keeps el on one line. Text width
     scales with font size (letter-spacing is in em), so one measurement
     gives the answer; a second read catches a 1px rounding overshoot. Two
     layouts per element instead of a binary search's six or seven. */
  function fitOneLine(el, min, max) {
    el.style.fontSize = max + "px";
    var sw = el.scrollWidth, cw = el.clientWidth;
    if (sw <= cw + 1) return max;
    var best = Math.max(min, Math.min(max, Math.floor(max * cw / sw)));
    el.style.fontSize = best + "px";
    if (best > min && el.scrollWidth > el.clientWidth + 1) { best -= 1; el.style.fontSize = best + "px"; }
    return best;
  }

  /* modal title: single line, as large as fits */
  function fitNutTitle() {
    var t = $("np-nut-title");
    if (!t) return;
    fitOneLine(t, 16, 30);
  }
  window.npFitNutTitle = fitNutTitle;

  /* section headings: one line wherever a modest shrink makes it fit (min 28px) */
  /* all headings in batched phases (write all, read all, write all, read,
     write) so the page lays out a few times in total rather than several
     times per heading */
  function fitHeadings() {
    var items = [];
    all(".np-h2fit").forEach(function (h) {
      /* the design sets the size via the `font` shorthand — restore it whole, never clear fontSize */
      if (h.dataset.npfont === undefined) h.dataset.npfont = h.style.font;
      h.style.font = h.dataset.npfont;
      h.style.whiteSpace = "nowrap";
      items.push({ h: h });
    });
    items.forEach(function (it) {
      it.max = parseFloat(getComputedStyle(it.h).fontSize);
      it.sw = it.h.scrollWidth; it.cw = it.h.clientWidth;
    });
    items.forEach(function (it) {
      if (it.sw <= it.cw + 1) return;
      it.size = Math.floor(it.max * it.cw / it.sw);
      if (it.size < 28) { it.size = 0; it.h.style.whiteSpace = ""; it.h.style.font = it.h.dataset.npfont; }
      else it.h.style.fontSize = it.size + "px";
    });
    items.filter(function (it) { return it.size && it.h.scrollWidth > it.h.clientWidth + 1; })
      .forEach(function (it) {
        if (it.size - 1 < 28) { it.size = 0; it.h.style.whiteSpace = ""; it.h.style.font = it.h.dataset.npfont; }
        else it.h.style.fontSize = (it.size - 1) + "px";
      });
    /* headings too long for one line wrap, but to two lines at most */
    items.forEach(function (it) { if (!it.size && it.h.style.whiteSpace === "") fitTwoLines(it.h, 24); });
  }

  /* never more than two lines: step the size down (to `min`) while the element wraps to three or more */
  function lines(el) {
    var cs = getComputedStyle(el);
    var lh = parseFloat(cs.lineHeight) || parseFloat(cs.fontSize) * 0.94;
    return Math.round(el.getBoundingClientRect().height / lh);
  }
  function fitTwoLines(el, min) {
    var size = parseFloat(getComputedStyle(el).fontSize), guard = 40;
    while (lines(el) > 2 && size > min && guard--) { size -= 1; el.style.fontSize = size + "px"; }
  }

  /* page title: the design's two lines, shrunk only when a long name would wrap to a third;
     titles marked one-line fit one line on mobile */
  function fitPageTitle() {
    var t = $("np-title");
    if (!t) return;
    var desk = parseInt(t.getAttribute("data-desktop"), 10) || 62;
    var mob = parseInt(t.getAttribute("data-mobile"), 10) || 44;
    /* VOLT product pages: one line at every width (Adam 3 Nov 2026: "Put Volt Titles on one line") */
    if (t.getAttribute("data-oneline") === "2") { fitOneLine(t, 24, window.innerWidth >= 1020 ? desk : mob); return; }
    if (window.innerWidth >= 1020) { t.style.fontSize = "clamp(42px, 4.40vw, " + desk + "px)"; fitTwoLines(t, 34); return; }
    t.style.fontSize = mob + "px";
    if (t.getAttribute("data-oneline") !== "1") { fitTwoLines(t, 28); return; }
    fitOneLine(t, 18, mob);
  }

  /* the nutrition modal title is fitted when the modal opens (it is hidden here) */
  function fitAll() { var nn = $("np-nut"); placeMeta(); if (nn && nn.style.opacity === "1") fitNutTitle(); fitHeadings(); fitPageTitle(); }
  fitAll();
  if (window.document.fonts && document.fonts.ready) { document.fonts.ready.then(fitAll); }

  /* one debounced resize handler for all four (was four separate listeners,
     each firing — and reflowing — on every pixel of a drag-resize); a
     width check skips runs where only the viewport HEIGHT changed, e.g. a
     mobile browser's toolbar or keyboard showing/hiding. */
  var npResizeTimer = null, npLastW = window.innerWidth;
  window.addEventListener("resize", function () {
    if (window.innerWidth === npLastW) return;
    npLastW = window.innerWidth;
    if (npResizeTimer) clearTimeout(npResizeTimer);
    npResizeTimer = setTimeout(fitAll, 120);
  });

  /* "In detail" on a phone: the words sit hidden on each photo; tap a photo (or its number) to show them, one at a
     time, as on trainvolt.com. Desktop shows every caption and the photos are not buttons. */
  var dtRoot = document.querySelector("[data-dt]");
  if (dtRoot) {
    var dtPhone = window.matchMedia("(max-width: 749px)");
    var dtTiles = [].slice.call(dtRoot.querySelectorAll("[data-dt-tile]"));
    var dtClose = function (keep) {
      dtTiles.forEach(function (t) { if (t !== keep) { t.classList.remove("is-open"); if (dtPhone.matches) t.setAttribute("aria-expanded", "false"); } });
    };
    var dtRoles = function () {
      dtTiles.forEach(function (t) {
        if (dtPhone.matches) { t.setAttribute("role", "button"); t.setAttribute("tabindex", "0"); t.setAttribute("aria-expanded", t.classList.contains("is-open") ? "true" : "false"); }
        else { t.removeAttribute("role"); t.removeAttribute("tabindex"); t.removeAttribute("aria-expanded"); t.classList.remove("is-open"); }
      });
    };
    dtTiles.forEach(function (t) {
      var go = function (e) {
        if (!dtPhone.matches) return;
        e.stopPropagation();
        var open = !t.classList.contains("is-open");
        dtRoot.classList.add("is-tapped");
        dtClose(t);
        t.classList.toggle("is-open", open);
        t.setAttribute("aria-expanded", open ? "true" : "false");
      };
      t.addEventListener("click", go);
      t.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); go(e); } });
    });
    document.addEventListener("click", function () { dtClose(null); });
    if (dtPhone.addEventListener) dtPhone.addEventListener("change", dtRoles);
    dtRoles();
  }

  /* MagnaSafe video (custom.magnasafe_video): muted loop that starts when it scrolls near, never with reduced
     motion; the button pauses and plays it. */
  var msv = document.querySelector("[data-ms-video]");
  if (msv) {
    var msb = document.querySelector("[data-ms-toggle]");
    var msSet = function () { if (msb) { var on = !msv.paused; msb.setAttribute("aria-label", on ? "Pause video" : "Play video"); msb.setAttribute("aria-pressed", on ? "false" : "true"); msb.querySelector("[data-ms-ic]").textContent = on ? "❚❚" : "▶"; } };
    msv.addEventListener("play", msSet); msv.addEventListener("pause", msSet);
    if (msb) msb.addEventListener("click", function () { if (msv.paused) { var pp = msv.play(); if (pp && pp.catch) pp.catch(function () {}); } else msv.pause(); });
    var msReduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!msReduce && "IntersectionObserver" in window) {
      new IntersectionObserver(function (es, io) {
        es.forEach(function (e) { if (e.isIntersecting) { var pp = msv.play(); if (pp && pp.catch) pp.catch(function () {}); io.disconnect(); } });
      }, { rootMargin: "200px 0px" }).observe(msv);
    }
    msSet();
  }

  render(); calc(); tabs();
  heroInit = false;
})();
